<template>
  <div class="form-group has-feedback">
    <input ref="el" readonly class="form-control" :placeholder="placeHolder"></input>
    <i class="glyphicon glyphicon-calendar form-control-feedback"></i>
  </div>
</template>

<script>
  // import moment from 'moment'
  import $ from 'jquery'
  import moment from 'moment'
  import daterangepicker from 'daterangepicker'
  import 'daterangepicker/daterangepicker-bs3.css'

  var dateRangeFormat = 'YYYY-MM-DD'
  var timeFormat = 'HH:mm:ss'

  const events = {
    'DATERANGE_CHANGE': 'daterange-change'
  }

  export default {
    events: events,

    data () {
      return {
        options: {
          timePicker: false,
          autoUpdateInput: true,
          format: dateRangeFormat,
          ranges: this.ranges
        },
        value: ''
      }
    },

    props: {
      placeHolder: {
        type: String,
        required: false,
        default: 'Choose Dates'
      },

      ranges: {
        type: Object,
        required: false,
        default: function () {
          return {
            'Last 1 days': [ moment().subtract(1, 'days'), moment() ],
            'Last 2 days': [ moment().subtract(2, 'days'), moment() ],
            'Last 7 days': [ moment().subtract(7, 'days'), moment() ],
            'Last 30 days': [ moment().subtract(30, 'days'), moment() ],
            'Last 2 months': [ moment().subtract(2, 'months'), moment() ]
          }
        }
      }
    },

    methods: {
      update: function (event, picker) {
        console.log('apply event', event.target.value)
        var matches = /(\d\d\d\d-\d\d-\d\d)\s+-\s+(\d\d\d\d-\d\d-\d\d)/.exec(event.target.value)
        var dateRange = [
          moment(matches[1] + '00:00:00', dateRangeFormat + timeFormat).format('x'),
          moment(matches[2] + '23:59:59', dateRangeFormat + timeFormat).format('x')
        ]

        this.value = event.target.value
        this.$emit(events.DATERANGE_CHANGE, dateRange)
      }
    },

    mounted () {
      this.$nextTick(() => {
        daterangepicker ? '' : '' // supress unused variable lint warning

        $(this.$refs.el).daterangepicker(this.options)
        $(this.$refs.el).on('apply.daterangepicker', this.update)
        // console.log('range', this.options.ranges['Last 7 days'][1].format())
      })
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// DateRangePicker.vue?f2e402ac